import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import Materialicon from "../helpers/Materialicon";
import LoaderInline from "../helpers/LoaderInline";

const DeleteModal = (props) => (
	<Modal bsSize="small" className="delete-modal" show={props.itemToDelete != null} onHide={props.closeModal}>
		<Modal.Body>
			<Materialicon icon="error_outline"/>
			<h4><b>Are you sure?</b></h4>
			<p className="msg">{`"${props.itemToDelete && props.itemToDelete.name}" will be removed!`}</p>
		</Modal.Body>

		<Modal.Footer>
			<Button bsStyle="danger" className="btn-min" disabled={props.isDeleting} onClick={props.deleteItem}>
				{props.isDeleting ? <LoaderInline width="20" height="20" color="#fff" /> : "Delete"}
			</Button>
			<Button bsStyle="default" className="btn-min"  onClick={props.closeModal}>Cancel</Button>
		</Modal.Footer>
	</Modal>
);

DeleteModal.defaultProps = {
	itemToDelete: null,
	isDeleting: false
};

DeleteModal.propTypes = {
	itemToDelete: PropTypes.shape({
		id: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number
		]),
		name: PropTypes.string,
	}),
	closeModal: PropTypes.func.isRequired,
	deleteItem: PropTypes.func.isRequired,
	isDeleting: PropTypes.bool
};
export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/modals/DeleteModal.js